<template>

    <div ref="documentContainer" class="content-with-sidebar-component agree-to-proceed end-user-license-agreement-component">

        <div class="container">
            <div class="row">

                <!-- Body -->
                <div class="col-8 body policy-wrap">
                    <div v-if="eulaPolicy">
                        <transition name="fade" mode="out-in">
                            <div>
                                <h1>{{ eulaHeading }}</h1>

                                <p>{{ eulaDescription }}</p>

                                <hr>

                                <policy-component :policy="eulaPolicy" :declarationText="eulaDeclarationText" @policyToggled="toggleAcceptEula"/>
                            </div>
                        </transition>
                    </div>
                    <footer-text v-if="footerText" :footerText="footerText" />
                </div>

                <!-- Sidebar -->
                <div class="col-4 sidebar">
                    <div>
                       <sidebar-get-in-touch :heading="sidebarsHeading" :description="sidebarsDescription" :emailAddress="sidebarsEmailAddress" :phoneNumber="sidebarsPhoneNumber" />
                    </div>
                </div>

            </div>
        </div>

    </div>

</template>

<script>
    import {EventBus} from '@/event-bus.js';
    import PolicyComponent from './policy-component';
    import SidebarGetInTouch from "./sidebar-get-in-touch";
    import FooterText from "./footer/footer-text";

    export default {

        components: {
            FooterText,
            SidebarGetInTouch,
            PolicyComponent
        },

        props: [
            'session',
            'adminPortalData',
            'adminPortalPrimaryProduct'
        ],

        data: () => {
            return {
                alreadyAccepted: null,
                eulaAccepted: null,
                eulaPolicy: null,
            }
        },

        computed: {
            eulaHeading() {
                return this.adminPortalPrimaryProduct.eula_heading;
            },
            eulaDescription() {
                return this.adminPortalPrimaryProduct.eula_description;
            },
            eulaDeclarationText() {
                return this.adminPortalPrimaryProduct.eula_declaration_text;
            },
            sidebarsDescription() {
                return this.adminPortalPrimaryProduct.sidebars_description;
            },
            sidebarsEmailAddress() {
                return this.adminPortalPrimaryProduct.sidebars_email_address;
            },
            sidebarsHeading() {
                return this.adminPortalPrimaryProduct.sidebars_heading;
            },
            sidebarsPhoneNumber() {
                return this.adminPortalPrimaryProduct.sidebars_phone_number;
            },
            footerText() {
                return this.adminPortalData.content?.products?.ecoamaps
                    && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description_required
                    && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description
                    ? this.adminPortalData.content.products.ecoamaps[0].fca_requirement_and_content_fca_description
                    : false;
            }
        },

        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.get();
            })
        },

        beforeRouteLeave (to, from, next) {
            // check if the continue button has been clicked.
            // if it has, then make the request to accept the policies.
            if(to.name !== 'Login' && to.name !== "Welcome Aboard" && to.name !== "Origo User Guide") {

                EventBus.$emit('loadingTitle', 'Accepted Policies');
                EventBus.$emit('loading', true);

                if (!this.eulaAccepted){
                    EventBus.$emit('loading', false);
                    EventBus.$emit('showError', true);
                    EventBus.$emit('errorTitle', 'Please agree all points to continue');
                    return false;
                }

                if (this.alreadyAccepted) {
                    EventBus.$emit('loading', false);
                    return next();
                }

                this.$http.post('/api/agree-to-proceed',
                    {
                        accept: true,
                        quotePolicyID: this.eulaPolicy.quotePolicyID
                    })
                    .then(response => {
                        EventBus.$emit('loading', false);
                        if(response.data.data.accepted) {
                            next();
                        }
                    })
                    .catch(err => {
                        EventBus.$emit('loading', false);
                        let response = err.response;

                        this.$notify({
                            group: 'notify',
                            type: 'error',
                            title: 'Error',
                            text: response.message
                        });
                        this.error = err.message.toString();
                        this.$router.push({ name: response.redirect });
                    });


            } else {
                next();
            }
        },

        methods: {
            scrollToTop() {
                this.$nextTick(() => {
                    this.$refs.documentContainer.scrollTop = 0;
                });
            },
            toggleAcceptEula() {
                this.eulaAccepted = !this.eulaAccepted;
                this.$emit('eulaAccepted', this.eulaAccepted);
            },
            get() {

                EventBus.$emit('loadingTitle', 'Fetching Policies');
                EventBus.$emit('loading', true);

                this.$http.get('/api/agree-to-proceed')
                    .then(response => {
                        EventBus.$emit('loading', false);
                        this.eulaAccepted = response.data.session.eulaAccepted;
                        this.$parent.eulaAccepted = this.eulaAccepted;
                        this.alreadyAccepted = this.eulaAccepted
                        this.eulaPolicy = response.data.data;

                        this.$emit('eulaAccepted', this.eulaAccepted);
                    })
                    .catch(err => {
                        EventBus.$emit('loading', false);
                        let response = err.response;

                        this.$notify({
                            group: 'notify',
                            type: 'error',
                            title: 'Error',
                            text: response.message
                        });
                        this.error = err.message.toString();
                        this.$router.push({ name: response.redirect });
                    });
            }
        }
    }
</script>
